/**
 * Helpers chuẩn hoá lỗi từ RTK Query / FastAPI.
 * BE FastAPI thường trả `{ detail: string | [...] }` hoặc envelope `{ message }`.
 */
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import type { SerializedError } from '@reduxjs/toolkit'

type AnyError = FetchBaseQueryError | SerializedError | unknown

interface ApiErrorBody {
  message?: string
  detail?: string | Array<{ msg?: string; loc?: unknown[] }>
}

export function getErrorMessage(err: AnyError, fallback = 'Đã xảy ra lỗi'): string {
  if (!err) return fallback

  // RTK Query FetchBaseQueryError
  if (typeof err === 'object' && err && 'status' in err) {
    const e = err as FetchBaseQueryError
    const body = e.data as ApiErrorBody | undefined
    if (body) {
      if (typeof body.message === 'string') return body.message
      if (typeof body.detail === 'string') return body.detail
      if (Array.isArray(body.detail) && body.detail.length > 0) {
        const first = body.detail[0]
        if (first && typeof first.msg === 'string') return first.msg
      }
    }
    if (typeof e.status === 'number') return `Lỗi HTTP ${e.status}`
    if (e.status === 'FETCH_ERROR') return 'Không kết nối được máy chủ'
    if (e.status === 'TIMEOUT_ERROR') return 'Máy chủ phản hồi quá lâu'
    if (e.status === 'PARSING_ERROR') return 'Phản hồi không hợp lệ'
  }

  // Serialized
  if (typeof err === 'object' && err && 'message' in err) {
    const msg = (err as { message?: string }).message
    if (typeof msg === 'string' && msg) return msg
  }

  return fallback
}
